import { render, staticRenderFns } from "./ValidatedUploadCard.vue?vue&type=template&id=6d37f74c&scoped=true"
import script from "./ValidatedUploadCard.vue?vue&type=script&lang=ts"
export * from "./ValidatedUploadCard.vue?vue&type=script&lang=ts"
import style0 from "./ValidatedUploadCard.vue?vue&type=style&index=0&id=6d37f74c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37f74c",
  null
  
)

export default component.exports